// extracted by mini-css-extract-plugin
export default {"container":"PollRequiredInput_container__0Zxc9"};